import Switch from "@mui/material/Switch"; 
import TooltipButton from "./tooltip/Popover";



const Tatdate = ({
  label = "",
  isChecked = false,
  onSwitchChange,
  inputValue, 
  onInputClick,
  fieldName,
  required = false, 
  showInput = true, 
  iscol,
  ismeet
}) => {
  return (
    <div className="row align-items-center mb-2">
     
      <div className={`${iscol ?"col-12" : "col-8"} d-flex align-items-center`} style={{ padding:!iscol && "0px" , justifyContent:!ismeet && "space-between" }}>
        <p style={{ whiteSpace:"nowrap", fontWeight:ismeet && 600, fontSize: "16px", margin: 0, display: "flex", alignItems: "center" }}>
          {label}
          {required && (
            <span style={{ color: "red", fontSize: "18px", fontWeight: "600", paddingLeft: "5px" }}>
              *
            </span>
          )}
          { ismeet && 
            <div  style={{ paddingLeft: "30px", marginTop: "0px" }}>
        <Switch
          color="primary"
          checked={isChecked}
          onChange={onSwitchChange}
        />
      </div>
          }
          {fieldName && (
            <span style={{ paddingLeft: "8px", display: "flex", alignItems: "center" , marginBottom:"4px" }}>
              <TooltipButton fieldName={fieldName} />
            </span>
          )}
        </p>
        { !ismeet && 
          <div  style={{ paddingLeft: "30px", marginTop: "0px" }}>
        <Switch
          color="primary"
          checked={isChecked}
          onChange={onSwitchChange}
        />
      </div>
        }
      </div>

      {showInput && inputValue && (
        <div className="col-12" style={{ padding: "0px" }}>
          <input
            style={{ paddingBottom: "0px", paddingTop: "0px", border:"none" }}
            type="text"
            className="form-control"
            value={inputValue}
            readOnly
            onClick={onInputClick}
          />
        </div>
      )}
    </div>
  );
};

export default Tatdate;
